import React, { useEffect, useState } from "react";
import { FaBaby, FaTrash, FaPlus } from "react-icons/fa";
import { GiQueenCrown, GiSharpCrown, GiWool, GiFamilyHouse, } from "react-icons/gi";
import { FaBan, FaCheck, FaTimes, FaUnlock } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "./AdminDashboard.css";
import { Button } from "@mui/material";
import AdminHeader from "../admin_module/AdminHeader";
import { useNavigate } from "react-router-dom";
import { collection, query, where, getDocs, deleteDoc, setDoc, doc, addDoc, updateDoc, getDoc, } from "firebase/firestore";
import { fs } from "../../firebase";
import { getPendingUsers, getApprovedUsers, getRejectedUsers, getBlockedUsers, approveUser as apiApproveUser, rejectUser as apiRejectUser, blockUser as apiBlockUser, postProductcodes, getProductcodes, deleteProductcodes, getSampleTypes, postSampleTypes, deleteSampleTypes, getCategories, postCategories, deleteCategories, getSubCategories, postSubCategories, deleteSubCategories, postProductTypes, getProductTypes, deleteProductTypes, getAuditLogs, getCategoryCounts, getFabricData } from "../../api";
import DashboardTab from "./DashboardTab";
import UserLogsTab from "./UserLogsTab";
import DropdownMasterTab from "./DropdownMasterTab";

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [pendingUsers, setPendingUsers] = useState([]);
  const [blockedUsers, setBlockedUsers] = useState([]);
  const [declinedUsers, setDeclinedUsers] = useState([]);
  const [activityLogs, setActivityLogs] = useState([]);
  const [apparelDropdowns, setApparelDropdowns] = useState([]);
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [miniTab, setMiniTab] = useState("ApprovedUsers");
  const [productCounts, setProductCounts] = useState({
    Men: 0,
    Kid: 0,
    Women: 0,
    Fabric: 0,
    "Home-accessories": 0,
  });
  const [productCodeList, setProductCodeList] = useState([]);
  const [sampleTypeList, setSampleTypeList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);

  const [newProductCode, setNewProductCode] = useState("");
  const [newSampleType, setNewSampleType] = useState("");
  const [newProductType, setNewProductType] = useState("");
  const [newCategory, setNewCategory] = useState("");
  const [newSubCategory, setNewSubCategory] = useState("");

  const categoryId = "gQ7tytWfp0CTYYTRFhLq";
  const subCategoryDocId = "0dUgm7vfiE3dY8OgyXJB";
  const productTypeDocId = "yDjQcA0FFAeN9a2PiA9N";

  const [dropdownTab, setDropdownTab] = useState("ProductCodes");

  useEffect(() => {
    getProductCodesValues();
    getSampleTypeList();
    getProductTypeList();
    getCategoryList();
    getSubCategoryList();
  }, []);

  useEffect(() => {
    getProductCodesValues();
    getSampleTypeList();
    getProductTypeList();
    getCategoryList();
    getSubCategoryList();
  }, []);

  useEffect(() => {
    fetchCategories();
    fetchProductCodes();
    fetchSampleTypes();
    fetchSubCategoryList();
    fetchProductTypes();
  }, []);

  const fetchSampleTypes = async () => {
    try {
      const response = await getSampleTypes();
      const list = response?.data || response || [];
      setSampleTypeList(list);
    } catch (error) {
      console.error("Error fetching sample types:", error);
    }
  };

  const fetchProductCodes = async () => {
    try {
      const response = await getProductcodes();
      const list = response?.data || response || [];
      setProductCodeList(list);
    } catch (error) {
      console.error("Error fetching product codes:", error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await getCategories();
      const list = response?.data || response || [];
      setCategoryList(list);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const fetchSubCategoryList = async () => {
    try {
      const response = await getSubCategories();
      const list = response?.data || response || [];
      setSubCategoryList(list);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const fetchProductTypes = async () => {
    try {
      const response = await getProductTypes();
      const list = response?.data || response || [];
      setProductTypeList(list);
    } catch (error) {
      console.error("Error fetching product types:", error);
    }
  };

  const handleAddProductCode = async () => {
    try {
      const newCode = newProductCode.trim();
      if (!newCode) {
        handleToast("Product Code cannot be empty", "warning");
        return;
      }

      const exists = productCodeList.some(item => {
        const itemVal = typeof item === 'object' ? item.product_code : item;
        return itemVal.toLowerCase() === newCode.toLowerCase();
      });

      if (exists) {
        handleToast("Product Code already exists", "warning");
        return;
      }

      await postProductcodes(newCode);
      await fetchProductCodes();

      setNewProductCode("");
      handleToast("Product Code added successfully", "success");
    } catch (error) {
      console.error("Error adding Product Code:", error);
      handleToast(error.message || "Error adding Product Code", "error");
    }
  };

  const handleAddSampleType = async () => {
    try {
      const newSample = newSampleType.trim();
      if (!newSample) {
        handleToast("Sample Type cannot be empty", "warning");
        return;
      }

      const exists = sampleTypeList.some(item => {
        const itemVal = typeof item === 'object' ? item.sample_type : item;
        return itemVal.toLowerCase() === newSample.toLowerCase();
      });

      if (exists) {
        handleToast("Sample Type already exists", "warning");
        return;
      }

      await postSampleTypes(newSample);
      await fetchSampleTypes();

      setNewSampleType("");
      handleToast("Sample Type added successfully", "success");
    } catch (error) {
      console.error("Error adding Sample Type:", error);
      handleToast(error.message || "Error adding Sample Type", "error");
    }
  };

  const handleAddCategory = async () => {
    try {
      const newCat = newCategory.trim();
      if (!newCat) {
        handleToast("Category name cannot be empty", "warning");
        return;
      }

      const exists = categoryList.some(item => {
        const itemVal = typeof item === 'object' ? item.category_name : item;
        return itemVal.toLowerCase() === newCat.toLowerCase();
      });

      if (exists) {
        handleToast("Category already exists", "warning");
        return;
      }

      await postCategories(newCat);
      await fetchCategories();

      setNewCategory("");
      handleToast("Category added successfully", "success");
    } catch (error) {
      console.error("Error adding category:", error);
      handleToast(error.message || "Error adding category", "error");
    }
  };

  const handleAddSubCategory = async () => {
    try {
      const newSubCat = newSubCategory.trim();
      if (!newSubCat) {
        handleToast("Subcategory name cannot be empty", "warning");
        return;
      }

      const exists = subCategoryList.some(item => {
        const itemVal = typeof item === 'object' ? item.subcategory_name : item;
        return itemVal.toLowerCase() === newSubCat.toLowerCase();
      });

      if (exists) {
        handleToast("Subcategory already exists", "warning");
        return;
      }

      await postSubCategories(newSubCat);
      await fetchSubCategoryList();

      setNewSubCategory("");
      handleToast("Subcategory added successfully", "success");
    } catch (error) {
      console.error("Error adding subcategory:", error);
      handleToast(error.message || "Error adding subcategory", "error");
    }
  };

  const handleAddProductType = async () => {
    try {
      const newType = newProductType.trim();
      if (!newType) {
        handleToast("Product Type cannot be empty", "warning");
        return;
      }

      const exists = productTypeList.some(item => {
        const itemVal = typeof item === 'object' ? item.product_type : item;
        return itemVal.toLowerCase() === newType.toLowerCase();
      });

      if (exists) {
        handleToast("Product Type already exists", "warning");
        return;
      }

      await postProductTypes(newType);
      await fetchProductTypes();

      setNewProductType("");
      handleToast("Product Type added successfully", "success");
    } catch (error) {
      console.error("Error adding Product Type:", error);
      handleToast(error.message || "Error adding Product Type", "error");
    }
  };

  const getProductCodesValues = async () => {
    try {
      const response = await getProductcodes();
      const list = response?.data || response || [];
      setProductCodeList(list);
    } catch (error) {
      console.error("Error fetching product codes:", error);
    }
  };

  const getSampleTypeList = async () => {
    try {
      const response = await getSampleTypes();
      const list = response?.data || response || [];
      setSampleTypeList(list);
    } catch (error) {
      console.error("Error fetching sample types:", error);
    }
  };

  const getProductTypeList = async () => {
    try {
      const response = await getProductTypes();
      const list = response?.data || response || [];
      setProductTypeList(list);
    } catch (error) {
      console.error("Error fetching product types:", error);
    }
  };

  const getCategoryList = async () => {
    try {
      const response = await getCategories();
      const list = response?.data || response || [];
      setCategoryList(list);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const getSubCategoryList = async () => {
    try {
      const response = await getSubCategories();
      const list = response?.data || response || [];
      setSubCategoryList(list);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
    }
  };

  const handleDeleteProductCode = async (codeObj) => {
    try {
      const productCodeText = typeof codeObj === 'object' ? codeObj.product_code : codeObj;
      const productCodeId = typeof codeObj === 'object' ? codeObj.id : null;

      const confirmation = window.confirm(
        `Are you sure you want to delete the product code : "${productCodeText}"?`
      );
      if (!confirmation) return;

      if (productCodeId) {
        await deleteProductcodes(productCodeId);
        setProductCodeList(productCodeList.filter((item) => item.id !== productCodeId));
      } else {
        const updatedProductCodes = productCodeList.filter(
          (code) => (typeof code === 'object' ? code.product_code : code) !== productCodeText
        );
        setProductCodeList(updatedProductCodes);
      }
      handleToast("Product Code deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting Product Code:", error);
      handleToast(error.message || "Error deleting Product Code", "error");
    }
  };

  const handleDeleteSampleType = async (typeObj) => {
    try {
      const typeText = typeof typeObj === 'object' ? typeObj.sample_type : typeObj;
      const typeId = typeof typeObj === 'object' ? typeObj.id : null;

      const confirmation = window.confirm(
        `Are you sure you want to delete the sample type : "${typeText}"?`
      );
      if (!confirmation) return;

      if (typeId) {
        await deleteSampleTypes(typeId);
        setSampleTypeList(sampleTypeList.filter((item) => item.id !== typeId));
      } else {
        const updatedSampleTypeList = sampleTypeList.filter(
          (type) => (typeof type === 'object' ? type.sample_type : type) !== typeText
        );
        setSampleTypeList(updatedSampleTypeList);
      }
      handleToast("Sample Type deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting Sample Type:", error);
      handleToast(error.message || "Error deleting Sample Type", "error");
    }
  };

  const handleDeleteCategory = async (categoryObj) => {
    try {
      const categoryText = typeof categoryObj === 'object' ? categoryObj.category_name : categoryObj;
      const categoryIdVal = typeof categoryObj === 'object' ? categoryObj.id : null;

      const confirmation = window.confirm(
        `Are you sure you want to delete the category : "${categoryText}"?`
      );
      if (!confirmation) return;

      if (categoryIdVal) {
        await deleteCategories(categoryIdVal);
        setCategoryList(categoryList.filter((item) => item.id !== categoryIdVal));
      } else {
        const updatedCategoryList = categoryList.filter(
          (category) => (typeof category === 'object' ? category.category_name : category) !== categoryText
        );
        setCategoryList(updatedCategoryList);
      }
      handleToast("Category deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting category:", error);
      handleToast(error.message || "Error deleting category", "error");
    }
  };

  const handleDeleteSubCategory = async (subCategoryObj) => {
    try {
      const subCategoryText = typeof subCategoryObj === 'object' ? subCategoryObj.subcategory_name : subCategoryObj;
      const subCategoryIdVal = typeof subCategoryObj === 'object' ? subCategoryObj.id : null;

      const confirmation = window.confirm(
        `Are you sure you want to delete the sub category : "${subCategoryText}"?`
      );
      if (!confirmation) return;

      if (subCategoryIdVal) {
        await deleteSubCategories(subCategoryIdVal);
        setSubCategoryList(subCategoryList.filter((item) => item.id !== subCategoryIdVal));
      } else {
        const updatedSubCategoryList = subCategoryList.filter(
          (subCategory) => (typeof subCategory === 'object' ? subCategory.subcategory_name : subCategory) !== subCategoryText
        );
        setSubCategoryList(updatedSubCategoryList);
      }
      handleToast("Subcategory deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting subcategory:", error);
      handleToast(error.message || "Error deleting subcategory", "error");
    }
  };

  const handleDeleteProductType = async (typeObj) => {
    try {
      const typeText = typeof typeObj === 'object' ? typeObj.product_type : typeObj;
      const typeId = typeof typeObj === 'object' ? typeObj.id : null;

      const confirmation = window.confirm(
        `Are you sure you want to delete the product type : "${typeText}"?`
      );
      if (!confirmation) return;

      if (typeId) {
        await deleteProductTypes(typeId);
        setProductTypeList(productTypeList.filter((item) => item.id !== typeId));
      } else {
        const updatedProductTypes = productTypeList.filter(
          (type) => (typeof type === 'object' ? type.product_type : type) !== typeText
        );
        setProductTypeList(updatedProductTypes);
      }
      handleToast("Product Type deleted successfully", "success");
    } catch (error) {
      console.error("Error deleting Product Type:", error);
      handleToast(error.message || "Error deleting Product Type", "error");
    }
  };

  useEffect(() => {
    const fetchProductCounts = async () => {
      try {
        const response = await getCategoryCounts();
        const countsData = response?.data || [];

        const counts = {
          Men: 0,
          Kid: 0,
          Women: 0,
          Fabric: 0,
          "Home-accessories": 0,
        };

        countsData.forEach(item => {
          if (!item.category) return;
          const cat = item.category.toUpperCase();
          if (cat === 'MEN' || cat === 'MENS') counts.Men = item.total_count;
          else if (cat === 'KIDS' || cat === 'KID') counts.Kid = item.total_count;
          else if (cat === 'WOMEN' || cat === 'WOMENS') counts.Women = item.total_count;
          else if (cat === 'FABRIC' || cat === 'FABRICS') counts.Fabric = item.total_count;
          else if (cat === 'HOME-ACCESSORIES' || cat === 'HOME ACCESSORIES') counts["Home-accessories"] = item.total_count;
        });

        const fabricResponse = await getFabricData();
        const fabricData = fabricResponse?.data || fabricResponse?.fabrics || fabricResponse?.fabric || fabricResponse || [];
        const fabrics = Array.isArray(fabricData) ? fabricData : fabricData ? [fabricData] : [];
        counts.Fabric = fabrics.length;

        setProductCounts(counts);
      } catch (error) {
        console.error("Error fetching product counts:", error);
      }
    };

    const fetchUsers = async () => {
      try {
        const approvedList = await getApprovedUsers();
        const list = approvedList?.data || approvedList || [];
        const formatted = Array.isArray(list) ? list.map(u => ({
          id: u.user_id || u.id || u._id,
          email: u.email,
          role: u.role || 'USER',
          status: u.status || 'APPROVED'
        })) : [];
        setUsers(formatted);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    const fetchPendingUsers = async () => {
      try {
        const pendingList = await getPendingUsers();
        const list = pendingList?.data || pendingList || [];
        const formatted = Array.isArray(list) ? list.map(u => ({
          id: u.user_id || u.id || u._id,
          email: u.email,
          role: u.role || 'USER',
          status: u.status || 'PENDING'
        })) : [];
        setPendingUsers(formatted);
      } catch (error) {
        console.error("Error fetching pending users:", error);
      }
    };

    const fetchBlockedUsers = async () => {
      try {
        const blockedList = await getBlockedUsers();
        const list = blockedList?.data || blockedList || [];
        const formatted = Array.isArray(list) ? list.map(u => ({
          id: u.user_id || u.id || u._id,
          email: u.email,
          role: u.role || 'USER',
          status: u.status || 'BLOCKED'
        })) : [];
        setBlockedUsers(formatted);
      } catch (error) {
        console.error("Error fetching blocked users:", error);
      }
    };

    const fetchDeclinedUsers = async () => {
      // Fetch declined users
      try {
        const querySnapshot = await getDocs(collection(fs, "declinedUsers")); // Assuming there's a 'declinedUsers' collection
        const declinedUsersList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setDeclinedUsers(declinedUsersList);
      } catch (error) {
        console.error("Error fetching declined users:", error);
      }
    };

    const fetchActivityLogs = async () => {
      try {
        const response = await getAuditLogs();
        const logsData = response?.data || response || [];
        setActivityLogs(logsData);
      } catch (error) {
        console.error("Error fetching activity logs:", error);
      }
    };

    fetchProductCounts();
    fetchUsers();
    fetchActivityLogs();
    if (activeTab === "UserLogs") {
      fetchPendingUsers();
      fetchBlockedUsers();
      fetchDeclinedUsers();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "DropdownMaster") {
      fetchApparelDropdowns(); // Fetch dropdowns when activeTab is "DropdownMaster"
    }
  }, [activeTab]);

  const fetchApparelDropdowns = async () => {
    try {
      // Assuming you have a collection named "ApparelDropdowns"
      const querySnapshot = await getDocs(collection(fs, "ApparelDropdowns"));
      const dropdownsList = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setApparelDropdowns(dropdownsList);
    } catch (error) {
      console.error("Error fetching apparel dropdowns:", error);
    }
  };



  const handleNavigate = (category) => {
    if (category === "Fabric") {
      navigate("/FabricGallery");
      return;
    }

    navigate(`/category/${category}`);
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const handleTabNavigate = (path) => {
    navigate(path);
  };

  const handleDropdownTabClick = (tab) => {
    setDropdownTab(tab);
  };

  const handleToast = (message, type) => {
    switch (type) {
      case "success":
        toast.success(message);
        break;
      case "error":
        toast.error(message);
        break;
      case "info":
        toast.info(message);
        break;
      default:
        toast(message);
        break;
    }
  };

  const approveUser = async (user) => {
    try {
      await apiApproveUser(user.id);

      // Remove the user from the pendingUsers state
      setPendingUsers(pendingUsers.filter((u) => u.id !== user.id));

      // If the user was previously declined, remove them from the declined users state
      setDeclinedUsers(declinedUsers.filter((u) => u.id !== user.id));

      // Add the user to the approved users state
      setUsers([...users, { ...user, approved: true }]);
      // Notify admin
      handleToast("User approved successfully", "success");
    } catch (error) {
      console.error("Error approving user:", error);
      handleToast(error.message || "Error approving user", "error");
    }
  };

  const declineUser = async (userId) => {
    try {
      await apiRejectUser(userId);
      const userToDecline = pendingUsers.find((user) => user.id === userId);
      setPendingUsers(pendingUsers.filter((u) => u.id !== userId));
      if (userToDecline) {
        setDeclinedUsers([...declinedUsers, { ...userToDecline, status: 'REJECTED' }]);
      }
      // Notify admin
      handleToast("User declined successfully", "success");
    } catch (error) {
      console.error("Error declining user:", error);
      handleToast(error.message || "Error declining user", "error");
    }
  };

  const blockUser = async (user) => {
    const confirmBlock = window.confirm(
      `Are you sure you want to block the user with email ${user.email}?`
    );

    if (confirmBlock) {
      try {
        // Call the block-user PUT API
        await apiBlockUser(user.id);

        // Remove the user from the 'users' state
        setUsers(users.filter((u) => u.id !== user.id));

        // Add the user to the 'blockedUsers' state
        setBlockedUsers([...blockedUsers, { ...user, status: 'BLOCKED' }]);

        // Notify admin
        handleToast("User blocked successfully", "success");
      } catch (error) {
        console.error("Error blocking user:", error);
        handleToast(error.message || "Error blocking user", "error");
      }
    } else {
      handleToast("User block action cancelled", "info");
    }
  };

  const unblockUser = async (user) => {
    const confirmUnblock = window.confirm(
      `Are you sure you want to unblock the user with email ${user.email}?`
    );

    if (confirmUnblock) {
      try {
        // Call the approve-user PUT API
        await apiApproveUser(user.id);

        // Update the state
        setBlockedUsers(blockedUsers.filter((u) => u.id !== user.id));
        setUsers([...users, { ...user, status: 'APPROVED' }]);
        // Notify admin
        handleToast("User unblocked successfully", "success");
      } catch (error) {
        console.error("Error unblocking user:", error);
        handleToast(error.message || "Error unblocking user", "error");
      }
    } else {
      handleToast("User unblock action cancelled", "info");
    }
  };

  return (
    <>
      <ToastContainer autoClose={1000} />
      <AdminHeader />
      <div className="admin-dashboard">
        <div className="tabs-section">
          <div className="tabs">
            <button
              className={activeTab === "Dashboard" ? "active" : ""}
              onClick={() => handleTabClick("Dashboard")}
            >
              Dashboard
            </button>
            <button
              className={activeTab === "UserLogs" ? "active" : ""}
              onClick={() => handleTabClick("UserLogs")}
            >
              User Logs
            </button>
            <button
              className={activeTab === "DropdownMaster" ? "active" : ""}
              onClick={() => handleTabClick("DropdownMaster")}
            >
              Dropdown Master
            </button>
          </div>
        </div>
        {/* <----------------------------------------------------Admin Dashboard section-------------------------------------------------------------> */}
        <div className="dashboard">
          {activeTab === "Dashboard" && (
            <DashboardTab
              productCounts={productCounts}
              handleNavigate={handleNavigate}
            />
          )}

          {/* <-----------------------------------------------------------------User log section---------------------------------------------------> */}
          {activeTab === "UserLogs" && (
            <UserLogsTab
              miniTab={miniTab}
              setMiniTab={setMiniTab}
              users={users}
              pendingUsers={pendingUsers}
              blockedUsers={blockedUsers}
              declinedUsers={declinedUsers}
              activityLogs={activityLogs}
              blockUser={blockUser}
              approveUser={approveUser}
              declineUser={declineUser}
              unblockUser={unblockUser}
            />
          )}

          {/* <---------------------------------------------------Dropdown Master section-------------------------------------------------------> */}
          {activeTab === "DropdownMaster" && (
            <DropdownMasterTab
              dropdownTab={dropdownTab}
              setDropdownTab={setDropdownTab}
              newProductCode={newProductCode}
              setNewProductCode={setNewProductCode}
              newSampleType={newSampleType}
              setNewSampleType={setNewSampleType}
              newCategory={newCategory}
              setNewCategory={setNewCategory}
              newSubCategory={newSubCategory}
              setNewSubCategory={setNewSubCategory}
              newProductType={newProductType}
              setNewProductType={setNewProductType}
              productCodeList={productCodeList}
              sampleTypeList={sampleTypeList}
              categoryList={categoryList}
              subCategoryList={subCategoryList}
              productTypeList={productTypeList}
              handleAddProductCode={handleAddProductCode}
              handleDeleteProductCode={handleDeleteProductCode}
              handleAddSampleType={handleAddSampleType}
              handleDeleteSampleType={handleDeleteSampleType}
              handleAddCategory={handleAddCategory}
              handleDeleteCategory={handleDeleteCategory}
              handleAddSubCategory={handleAddSubCategory}
              handleDeleteSubCategory={handleDeleteSubCategory}
              handleAddProductType={handleAddProductType}
              handleDeleteProductType={handleDeleteProductType}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default AdminDashboard;
